import React, { useEffect, useState } from "react";
import { collection, query, where, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";

/**
 * THE REGISTER — the public, verifiable roll of ATELIER-certified designers.
 * Deliberately reachable without sign-in: a roll nobody can check is a rumour.
 */
export default function Register() {
  const [rows, setRows] = useState([]);
  const [qtext, setQtext] = useState("");

  useEffect(() => onSnapshot(
    query(collection(db, "register"), where("status", "==", "active"), orderBy("issuedAt", "desc")),
    (snap) => setRows(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
  ), []);

  const list = rows.filter((r) => !qtext
    || r.name?.toLowerCase().includes(qtext.toLowerCase())
    || r.credentialId?.toLowerCase().includes(qtext.toLowerCase()));

  return (
    <div style={{ background: "var(--paper)", minHeight: "100vh" }}>
      <header className="masthead">
        <div className="wrap" style={{ paddingTop: 22, paddingBottom: 22 }}>
          <div style={{ fontFamily: "Archivo, sans-serif", fontWeight: 700, letterSpacing: ".34em", fontSize: 22 }}>ATELIER</div>
          <div style={{ fontSize: 13, color: "#93a0ac" }}>The Register of Certified AI-Native Web Designers · <a href="/annual" style={{ color: "#93a0ac" }}>The Annual</a></div>
        </div>
      </header>
      <div className="wrap" style={{ paddingTop: 24, paddingBottom: 60, maxWidth: 860 }}>
        <p style={{ maxWidth: "66ch" }}>
          Every designer on this roll completed the six-month ATELIER programme, passed all six mastery
          gates — including a manual accessibility audit and a live oral defence before external examiners —
          and holds a verifiable credential. Employers: search by name or credential ID; if it is not on
          this page, it was not issued.
        </p>
        <input type="text" placeholder="Search by name or credential ID (e.g. ATL-RT01-8F2A1C)"
          value={qtext} onChange={(e) => setQtext(e.target.value)}
          style={{ margin: "18px 0", padding: "10px 12px", fontSize: 15 }} />

        {list.map((r) => (
          <div key={r.id} className="card" style={{ marginBottom: 12 }}>
            <div className="row between wrapflex">
              <div>
                <strong style={{ fontSize: 17 }}>{r.name}</strong>
                <div style={{ fontSize: 14, color: "var(--graphite)" }}>
                  {r.credential} · <em>{r.award}</em>
                </div>
                {r.capstoneTitle && <div style={{ fontSize: 13, marginTop: 4 }}>Capstone: {r.capstoneTitle}</div>}
              </div>
              <div className="mono" style={{ fontSize: 12, textAlign: "right", color: "var(--graphite)" }}>
                <div>{r.credentialId}</div>
                <div>{r.cohortId}</div>
                <div>{r.issuedAt?.toDate?.().toLocaleDateString?.() ?? ""}</div>
              </div>
            </div>
          </div>
        ))}
        {!list.length && (
          <p style={{ color: "var(--graphite)", fontStyle: "italic" }}>
            {qtext ? "No matching credential. If someone presented this ID, it is not valid." : "The first cohort has not yet reached Jury Day. The roll begins there."}
          </p>
        )}
      </div>
    </div>
  );
}
